import { allStates, allStatesAndZones, trashStates, zoneMappings, zones } from "../../models/states";
export var FilterType;
(function (FilterType) {
    FilterType[FilterType["Include"] = 0] = "Include";
    FilterType[FilterType["Exclude"] = 1] = "Exclude";
})(FilterType || (FilterType = {}));
export class AreaFilter {
    constructor(type, value) {
        this.type = type;
        this.value = value.toUpperCase();
    }
    typeString() {
        return this.type === FilterType.Exclude ? '-' : '';
    }
    toString() {
        return `${this.typeString()}${this.value}`;
    }
    isSpecial() {
        return availableFilters.includes(this.toString());
    }
    isValid() {
        return this.value.length > 0;
    }
    isComplete() {
        if (this.value.length === 0 || this.value.length > 3) {
            return false;
        }
        if (this.value.length === 2) {
            return allStatesAndZones.includes(this.value);
        }
        return availableFilters.includes(this.toString());
    }
    suggest() {
        if (!this.isValid())
            return '';
        if (this.isComplete()) {
            return this.toString();
        }
        let specialSuggestion = availableFilters.find(s => s.startsWith(this.toString()));
        if (specialSuggestion) {
            this.value = specialSuggestion.substring(1);
            return specialSuggestion;
        }
        let suggestion = allStatesAndZones.find(s => s.startsWith(this.value));
        if (suggestion) {
            this.value = suggestion;
            return this.toString();
        }
        return '';
    }
    split() {
        let matches = this.value.match(/.{2}/g);
        if (matches)
            return matches.map(t => new AreaFilter(this.type, t));
        return [this];
    }
    static fromString(str) {
        if (str.startsWith('-')) {
            return new AreaFilter(FilterType.Exclude, str.substring(1));
        }
        return new AreaFilter(FilterType.Include, str);
    }
}
export const availableFilters = ['-ELD'];
export function finalizeAreaFilters(filters) {
    let result = [];
    if (filters.some(f => f.type === FilterType.Exclude)) {
        result = allStates;
    }
    for (let filter of filters) {
        if (!filter.isComplete())
            continue;
        if (filter.type === FilterType.Include) {
            if (!result.includes(filter.value)) {
                result.push(filter.value);
            }
        }
        else {
            if (filter.isSpecial()) {
                if (filter.value === 'ELD') {
                    result = result.filter(s => !trashStates.includes(s));
                }
            }
            else if (zones.includes(filter.value)) {
                result = result.filter(s => !zoneMappings[filter.value].includes(s));
            }
            else {
                result = result.filter(s => s !== filter.value);
            }
        }
    }
    return result;
}
export function parseAreasFilters(v) {
    let areaFilters = [];
    let tokens = v.split(/[ ,]+/gi).filter(t => t);
    for (let t of tokens) {
        let f = AreaFilter.fromString(t);
        if (f.isSpecial()) {
            areaFilters.push(f);
        }
        else {
            areaFilters = areaFilters.concat(f.split());
        }
    }
    return areaFilters;
}
export class Suggestion {
    constructor(value, type) {
        this.value = value;
        this.type = type;
    }
    static city(value, placeId) {
        let s = new Suggestion(value, 'city');
        s.id = placeId;
        return s;
    }
    static area(value, areaFilters) {
        let s = new Suggestion(value, 'area');
        s.areaFilters = areaFilters;
        return s;
    }
}
